import { render } from "./PreActionPremium.vue?vue&type=template&id=20e8224c&scoped=true"
import script from "./PreActionPremium.vue?vue&type=script&lang=js"
export * from "./PreActionPremium.vue?vue&type=script&lang=js"

import "./PreActionPremium.vue?vue&type=style&index=0&id=20e8224c&scoped=true&lang=scss"
import "./PreActionPremium.vue?vue&type=style&index=1&id=20e8224c&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e8224c"]])

export default __exports__